import {Injectable} from '@angular/core';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';
import {AuthService} from './auth.service';
import {StaticMethods} from '../model/GeneralModels';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(private http: HttpClientWrapperService,
              private authService: AuthService) {
  }

  getFormQuestions(productName: string, requestID: number, subset: number) {
    return this.http.get(`common/${productName}/${requestID}/questions?subset=${subset}`, this.authService.decode().auth);
  }

  getBasicInformationQuestions(productName: string, subset: number) {
    return this.http.get(`common/${productName}/basic-information-form?subset=${subset}`);
  }

  getSubRequestInfo(subRequestID: number) {
    return this.http.get(this.authService.decode().Role + '/subRequestInfo?id=' + subRequestID + '&userType=' +
      this.authService.decode().Role.toUpperCase(), this.authService.decode().auth);
  }

  searchNearMe(form: any) {
    return this.http.post('locations/near-me', form);
  }

  getTypeList(productName: string, companyName: string) {
    return this.http.get(`locations/types-list?productName=${productName}&companyName=${companyName}`);
  }

  submitForms(productName, form: any, requestID: number, subRequestID: number) {
    form.requestID = requestID;
    form.subRequestID = subRequestID;
    const url = `common/${productName}/submit-forms`;
    return this.http.post(url, form, this.authService.decode().auth);
  }

  getClientCompanyList(productName: string) {
    return this.http.get(`common/${productName}/getCompanies`);
  }

  checkAgentCode(company: string, agentCode: string, productName: string) {
    return this.http.get(`common/${productName}/checkAgentCode?agentCode=${agentCode}&company=${company}`);
  }

  getRequestsList(productName) {
    return this.http.get(`common/${productName}/requests`, this.authService.decode().auth);
  }

  getPersonalInfo() {
    return this.http.get(`usersinf/profile`, this.authService.decode().auth);
  }

  submitPersonalInfo(body: any) {
    return this.http.post(`usersinf/profile/update`, body, this.authService.decode().auth);
  }

  getNotes(requestID: number, productName: string) {
    return this.http.get(`common/notes/${productName}/${requestID}`, this.authService.decode().auth);
  }

  deleteRequest(requestID: number, productName: string, description: string) {
    return this.http.post(`common/delete`, {
      requestID,
      productName,
      description
    }, this.authService.decode().auth);
  }

  private getUserBaseUrl(role) {
    switch (role) {
      case 'user':
        return 'Usersinf';
      case 'external-employee':
        return 'external-employee';
      default:
        throw new Error('user role not supported');
    }
  }

  getCode(mobile: string, role: string) {
    const baseUrl = this.getUserBaseUrl(role);
    return this.http.get(`${baseUrl}/getSecurityCode?mobile=${mobile}`);
  }

  loginUser(securityCode: string, mobile: string, role: string) {
    const baseUrl = this.getUserBaseUrl(role);
    return this.http.get(baseUrl + '/register?mobile=' + mobile + '&securityCode=' + securityCode);
  }

  downloadFormsFile(requestID: number, productName: string, userType: string) {
    return this.http.get(`common/generateFormsPdf/${productName}/${requestID}?userType=${userType}`, this.authService.decode().auth);
  }

  createRequest(productName: string, formsData: any) {
    let baseUrl;
    switch (productName) {
      case 'HEALTH':
        baseUrl = 'SamanAPI/HealthRequests/create';
        break;
      case 'INDIVIDUAL_ACCIDENTS':
        baseUrl = 'individual-accidents/insurance/create';
        break;
      case 'MOBILE':
        baseUrl = 'mobile/insurance/create';
        break;
      case 'PET':
        baseUrl = 'pet/insurance/create';
        break;
      case 'HEALTH_GROUP':
        baseUrl = 'health-group/insurance/create';
        break;
      default:
        throw new Error('product Not Supported');
    }
    if (baseUrl) {
      return this.http.post(baseUrl, formsData, this.authService.decode().auth);
    }
  }

  checkCreationRequirement(productName: string, body: any) {
    return this.http.post(`common/${productName}/check-creation-requirements`, body);
  }
}
